<template>
  <span class="positive-id-gate">
    <slot :requestVerification="requestVerification" :verifying="verifying" />

    <PositiveIdModal
      :show.sync="modalShown"
      :action-type="actionType"
      :target-entity-type="targetEntityType"
      :target-entity-id="targetEntityId"
      :enabled-methods="enabledMethods"
      @verified="onVerified"
      @cancelled="onCancelled"
    />
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import PositiveIdModal from './PositiveIdModal.vue';
import { PositiveIdActionType, PositiveIdTargetEntityType } from '@/services/PositiveIdService';

@Component({ components: { PositiveIdModal } })
export default class PositiveIdGate extends Vue {
  @Prop({ type: Number, required: true }) readonly actionType!: PositiveIdActionType;
  @Prop({ type: Number, required: true }) readonly targetEntityType!: PositiveIdTargetEntityType;
  @Prop({ type: String, required: true }) readonly targetEntityId!: string;
  @Prop({ type: Array, default: null }) readonly enabledMethods!: string[] | null;
  /**
   * When false (positive identification disabled in Configuration), the gate is a pass-through:
   * <code>requestVerification</code> immediately emits a no-token <code>verified</code> event so the
   * caller can proceed without showing the modal. The backend <code>[RequirePositiveId]</code> filter
   * is also a no-op when the toggle is off, so requests without the header are accepted.
   */
  @Prop({ type: Boolean, default: true }) readonly enabled!: boolean;

  private modalShown = false;
  private verifying = false;

  requestVerification(): void {
    if (!this.enabled) {
      this.$emit('verified', { verifiedToken: '' });
      return;
    }
    this.verifying = true;
    this.modalShown = true;
  }

  private onVerified(payload: { verifiedToken: string }): void {
    this.verifying = false;
    this.modalShown = false;
    this.$emit('verified', payload);
  }

  private onCancelled(): void {
    this.verifying = false;
    this.modalShown = false;
    this.$emit('cancelled');
  }
}
</script>
